
import React from 'react';
import Header from '@/components/layout/Header';
import MusicRightsAdministration from '@/components/royalties/MusicRightsAdministration';
import { FileText } from 'lucide-react';

const MusicRightsAdmin: React.FC = () => {
  return (
    <div className="min-h-screen bg-background bg-gradient-to-b from-background to-background/80">
      <Header />
      
      <main className="pt-24 pb-28 px-4 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8 animate-fade-in">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold flex items-center gap-3 bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
              <FileText className="h-10 w-10 text-blue-500" />
              Music Rights Administration
            </h1>
            <p className="text-muted-foreground text-lg">Manage your catalog and streamline registrations with PROs and rights agencies</p>
          </div>
        </div>
        
        <div className="space-y-8 animate-slide-up">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 to-indigo-500/20 blur-2xl -z-10 rounded-3xl"></div>
            <MusicRightsAdministration />
          </div>
        </div>
      </main>
    </div>
  );
};

export default MusicRightsAdmin;
